import { AddToAnyViewModel } from 'stageclip-common';

export const getPositionOfButtons = (socialButons: AddToAnyViewModel[]) =>
  socialButons?.map((social, i) => ({ [social.displayName]: i }));
